import React from 'react'
import './styles.scss'
import { message } from 'antd'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import BlockUi from 'react-block-ui'
import 'react-block-ui/style.css'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import Header  from '../../../components/FileCatalyst/History/history-header'
import Files   from './transfer-list'

class Transfers extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      files   : [],
      loading : false,

      page  : 1,
      limit : 100,
      total : 0
    }
  }

  componentDidMount() {
    this.on_refresh()
  }

  on_refresh = () => {
    let $this = this
    this.setState({loading:false})

    CloudFlyerAPI.transfer
      .history(this.state.page, this.state.limit, 'file_catalyst')
      .then(res =>{
        $this.setState({
          files: ((res||{}).data||{}).transfers,
          loading : false,
          total : ((res||{}).data||{}).count
        })
      })
      .catch(e =>{
        $this.setState({loading:false})
        console.error(e)
        message.error('Failed to retrieve transfers history, please try again')
      })
  }

  render() {
    const {files, loading} = this.state

    return (
      <BlockUi className='transfers-history' blocking={loading}>

        <Header title={''} disabled  = {true}/>

        <hr/>

        <Files
          key     = {'Files'}
          files   = {this.state.files}
          loading = {this.state.loading}
        />
      </BlockUi>
    )
  }
}

export default withRouter(connect(
  ({}) => {
    return {}
  }, (dispatch) => bindActionCreators({

  }, dispatch))(Transfers))
